/**
 * Sign Up page with Clerk integration
 */


import { SignUp } from '@clerk/clerk-react';

export default function SignUpPage() {
  return (
    <div className='min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800'>
      <div className='w-full max-w-md'>
        <div className='text-center mb-8'>
          <h1 className='text-3xl font-bold text-gray-900 dark:text-white'>
            Únete a Grade
          </h1>
          <p className='text-gray-600 dark:text-gray-400 mt-2'>
            Crea tu cuenta para empezar a evaluar LLMs
          </p>
        </div>

        <div className='bg-white dark:bg-gray-900 shadow-xl rounded-lg p-6'>
          <SignUp
            appearance={{
              elements: {
                card: 'shadow-none',
                headerTitle: 'hidden',
                headerSubtitle: 'hidden',
              },
            }}
            routing='path'
            path='/auth/sign-up'
            afterSignUpUrl='/dashboard'
            signInUrl='/auth/sign-in'
          />
        </div>

        <div className='text-center mt-6'>
          <p className='text-sm text-gray-600 dark:text-gray-400'>
            Sistema de Evaluación Inteligente para LLMs
          </p>
        </div>
      </div>
    </div>
  );
}
